<template>
<div>
  <p class="is-size-5">Laravel Version Spread</p>
  <div id="version-spread-donut">
    <apexchart type="donut" :options="options" :series="series"></apexchart>
  </div>
</div>
</template>
<script>
export default {

  props: {
    spread: {
      type: Array
    },
  },

  computed: {
    series() {
      return this.spread.map((item) => item.count)
    },
    labels() {
      return this.spread.map((item, key) => item.version)
    },
    options() {
      return {
        labels: this.labels,
        theme: {
          monochrome: {
            enabled: true,
            color: '#12a2ff',
            shadeTo: 'dark',
            shadeIntensity: 0.8
          }
        },
        stroke: {
          show: true,
          curve: 'smooth',
          lineCap: 'butt',
          colors: undefined,
          width: 1,
          dashArray: 0,
        },
        legend: {
          labels: {
            colors: '#efefefef'
          }
        }
      }
    }
  }
}
</script>
